import React from "react";
import LimitesPix from "../../../components/acesso-rapido/pix/limites-pix/LimitesPix";

const PaginaLimitesPix = () => {
  return <LimitesPix />;
};

export default PaginaLimitesPix;
